import React, { useState } from 'react';
import {
  Avatar,
  IconButton,
  Tooltip,
  Typography
} from '@mui/material';
import {
  Share,
  Star,
  StarBorder,
  CalendarToday,
  MonetizationOn,
  Group,
  Person
} from '@mui/icons-material';
import MissionDetailsModal from './MissionDetailsModal';
import './MissionCardList.css';
import { Box } from '@mui/system';

const MissionCardList = ({
  mission,
  isFavorite,
  onToggleFavorite,
  onShare,
  onView
}) => {
  const [logoError, setLogoError] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const logoUrl = mission.logoUrl
    ? `${process.env.REACT_APP_API_BASE_URL}${mission.logoUrl}`
    : '';
  const fallbackInitial = mission.company?.charAt(0)?.toUpperCase() || 'E';
  const devise = mission.devise || '€';

  return (
    <div className={`mission-list-card ${isFavorite ? 'fav-bg' : ''}`}>
      <div className="mission-list-row">
        <div className="mission-logo-block">
          <IconButton onClick={() => onToggleFavorite(mission._id)}>
            {isFavorite ? <Star className="star-active" /> : <StarBorder />}
          </IconButton>
          <Tooltip title="Partager">
              <IconButton onClick={() => onShare(mission)}>
                <Share fontSize="small" />
              </IconButton>
            </Tooltip>
          {!logoError && logoUrl ? (
            <img
              src={logoUrl}
              alt="logo"
              className="mission-logo"
              onError={() => setLogoError(true)}
            />
          ) : (
            <Avatar variant="rounded" className="fallback-avatar">
              {fallbackInitial}
            </Avatar>
          )}
          {mission.isNew && <span className="badge-new-list">NOUVEAU</span>}
        </div>

        <div className="mission-info-content">
          <div className="mission-top-row">
            <Box onClick={() => onView(mission._id)} sx={{ cursor: 'pointer' }}>
              <Typography variant="subtitle1" className="mission-title" noWrap>
                {mission.nomMission}
              </Typography>
            </Box>
          </div>

          <div className="mission-inline-info-row">
            <span>
              <CalendarToday fontSize="small" className="info-icon" /> 
              <strong>{mission.date}</strong>
            </span>
            <span>
              <MonetizationOn fontSize="small" className="info-icon" /> 
              <strong>Prime : {mission.reward} {devise}</strong>
            </span>
            <span title={mission.location || 'Lieu non spécifié'}>
              📍 <strong>
                {mission.location || 'Lieu non spécifié'}
              </strong>
            </span>
            <span>
              <Group fontSize="small" className="info-icon" /> 
              <strong>{mission.availableSpots}</strong>  Poste(s) ouvert(s)
            </span>
            <span>
              <Person fontSize="small" className="info-icon" /> 
              <strong>{mission.candidates}</strong> candidat(s) positionné(s)
            </span>
          </div>
        </div>

        <MissionDetailsModal
          open={showModal}
          onClose={() => setShowModal(false)}
          mission={mission}
        />
      </div>
    </div>
  );
};

export default MissionCardList;
